import * as _ from 'underscore';
import { Modal } from './modal';
import { FilterTableItem } from './filterTableItem';
import { Table, Event } from '..';
import { IEvent } from '../../interfaces';
import {
	FilterOptions,
	PagingOptions,
	FilterColumnOptions,
	ModalOptions
} from '../../interfaces/options';
import { Combobox, Button } from '../ui/uiElements';
import { SelectionMode } from '../../enums';
import { Templates } from '../../compile';
import { ID, Icons, Size } from '../../const';
import { DefaultTableCommandColumnOptions } from '../../const/defaultOptions';
import { Localization } from '../../compile';

export class FilterModal extends Modal {
	private columns: Combobox<FilterColumnOptions>;
	private columnsData: KnockoutObservableArray<FilterColumnOptions>;
	private addFilterButton: Button;
	private filterTable: Table<FilterTableItem>;
	private filterTableData: KnockoutObservableArray<FilterTableItem>;

	private _changed: Event<FilterOptions[]>;
	public get Changed(): IEvent<FilterOptions[]> {
		return this._changed;
	}

	private clickClear: () => void;

	constructor(filterColumns: FilterColumnOptions[]) {
		super(<ModalOptions>{
			contentTemplate: Templates.modal_filter,
			height: '55%',
			title: Localization.Filter,
			closeLabel: Localization.ClearAll
		});

		this._changed = new Event<FilterOptions[]>();

		this.Closed.subscribe(() => {
			this.notify();
		});

		this.clickClear = () => {
			this.filterTableData.removeAll();
			this.close();
		};

		this.columnsData = ko.observableArray<FilterColumnOptions>(filterColumns);
		this.columns = new Combobox<FilterColumnOptions>(
			ID.Columns,
			Localization.Columns,
			null,
			this.columnsData,
			{
				size: Size._6_8,
				template: Templates.layouts_uiElements_noValidation
			}
		);

		this.addFilterButton = new Button(ID.AddFilter, Localization.AddFilter, Icons.AddFilter, {
			size: Size._2_8
		});

		this.addFilterButton.Clicked.subscribe(() => {
			this.addFilter(this.columns.value());
		});

		this.filterTableData = ko.observableArray<FilterTableItem>([]);
		this.filterTable = new Table<FilterTableItem>({
			selectionMode: SelectionMode.NONE,
			dataSource: {
				data: this.filterTableData,
				paging: <PagingOptions>{
					pageSize: 4
				}
			},
			properties: [
				{ key: 'label', label: Localization.Column, isSortable: false, isFilterable: false },
				{
					key: 'operator',
					label: Localization.Filter,
					isSortable: false,
					isFilterable: false,
					template: Templates.list_cell_filterOperator
				},
				{
					key: 'value',
					label: Localization.Value,
					isSortable: false,
					isFilterable: false,
					template: Templates.list_cell_filterInput
				},
				DefaultTableCommandColumnOptions<FilterTableItem>()
			],
			confirmBeforeDelete: false
		});
	}

	public addFilter(filterColumn?: FilterColumnOptions, notify?: boolean) {
		if (filterColumn) {
			this.filterTableData.push(new FilterTableItem(filterColumn));
			if (notify) {
				this.notify();
			}
		}
	}

	public isActiveFilterById(id: string): boolean {
		let filterTableItems = this.filterTableData();
		return _.some(filterTableItems, filter => filter.key === id);
	}

	public removeFilterById(id: string, notify?: boolean): void {
		let filterTableItems = this.filterTableData();
		let filterTableItem = _.find(filterTableItems, filter => filter.key === id);
		if (filterTableItem) {
			this.filterTableData.remove(filterTableItem);
			if (notify) {
				this.notify();
			}
		}
	}

	private notify(): void {
		this._changed.notify(this.getFilterSettings());
	}

	public getFilterSettings(): FilterOptions[] {
		var filterData = this.filterTableData();

		if (filterData.length > 0) {
			return filterData.map(filter => filter.toFilterSetting());
		}

		return [];
	}
}
